module.exports = __webpack_public_path__ + "media/bootstrap-icons/text-left-6d599bfb.svg";